export default {"src":"/_next/static/media/ns_logo_full_green.cdf09aee.svg","height":80,"width":300,"blurWidth":0,"blurHeight":0};